"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropdownDivider;
var _react = _interopRequireDefault(require("react"));
/**
 * Create divider which visually seperates DropdownItems.
 *
 * @function DropdownDivider
 * @returns {React.ReactComponent} DropdownDivider
 * @displayName DropdownDivider (Web)
 * @public
 */
function DropdownDivider() {
  return /*#__PURE__*/_react.default.createElement("hr", {
    role: "presentation",
    className: "dropdown-divider"
  });
}